export default __webpack_public_path__ + "static/media/logo-m.1dc7ba07.svg";